import * as React from 'react';
import styles from './ResultsListItem.module.esm.js';

var ResultsListItem = function (_a) {
    var title = _a.title, onClick = _a.onClick, url = _a.url, active = _a.active, resultIndex = _a.resultIndex, setSelectedResultIndex = _a.setSelectedResultIndex;
    var ref = React.useRef(null);
    var focus = React.useCallback(function () { var _a; return active && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus()); }, [active]);
    React.useEffect(function () {
        focus();
    }, [active, focus]);
    return (React.createElement("li", null,
        React.createElement("a", { className: styles.root, dangerouslySetInnerHTML: { __html: title }, href: url, onBlur: function () { return setSelectedResultIndex(null); }, onClick: onClick, onFocus: function () { return setSelectedResultIndex(resultIndex); }, ref: ref })));
};

export { ResultsListItem };
//# sourceMappingURL=ResultsListItem.esm.js.map
